<template>
  <div class="book-detail">
    <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li><router-link :to="{ name: 'ebook', query: { book_active: 0, classes: 1 } }">Sách điện tử</router-link>
          </li>
          <li v-if="ebooksDetail && ebooksDetail.className">
            <router-link v-if="ebooksDetail.classId != null"
              :to="{ name: 'ebook', query: { book_active: tabActiveInBookList, classes: ebooksDetail.classId } }">
              {{ ebooksDetail.className }}
            </router-link>
          </li>
          <li v-if="ebooksDetail && ebooksDetail.bookTypeName">
            <router-link v-if="ebooksDetail.classId != null"
              :to="{ name: 'ebook', query: { book_active: tabActiveInBookList, classes: ebooksDetail.classId } }">
              {{ ebooksDetail.bookTypeName }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'ebook-detail', params: { id: this.id, slug: this.slug } }">{{ ebooksDetail.name
            }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="ss-page book-detail__data">
      <div class="container-hts">
        <div class="row">
          <div class="col-lg-4 col-12">
            <div class="book-detail__img text-center">
              <router-link
                :to="{ name: 'ebook-read-book', params: { id: ebooksDetail.bookId, slug: ebooksDetail.slug } }">
                <div class="book-detail__img__wrap position-rel text-center">
                  <!-- <img v-if="ebooksDetail.imageUrl!=null" v-lazy="img.src" :src="ebooksDetail.imageUrl!=null?cdnUrl +ebooksDetail.imageUrl.replace('Content//images','images'):''" :alt="ebooksDetail.name"> -->
                  <img v-if="ebooksDetail.imageUrl !== null"
                    :src="ebooksDetail.imageUrl ? handleResizeImg(ebooksDetail.imageUrl) : ''"
                    :alt="ebooksDetail && ebooksDetail.name ? ebooksDetail.name : ''">
                  <router-link class="btn btn-main btn-viewbook"
                    :to="{ name: 'ebook-read-book', params: { id: ebooksDetail.bookId, slug: ebooksDetail.slug } }">Đọc
                    sách</router-link>
                </div>
              </router-link>
            </div>
          </div>
          <div class="col-lg-8 col-12 book-detail__content">
            <div class="book-detail__head">
              <h1 class="book-detail__name font-size-24 primary-color-txt font-sanpro-semibold">{{ ebooksDetail.name }}
              </h1>
              <div class="book-detail__meta" v-if="ebooksDetail && ebooksDetail.publishStatusId">
                <!--  <p class="margin-0 font-size-16 red-color-txt">(Bản mẫu đang thẩm định)</p> -->
                <p class="margin-0 font-size-16 red-color-txt">{{ ebooksDetail.publishStatusName }}</p>
              </div>
              <div class="book-detail__meta">
                <p class="margin-0 font-size-16 secondary-color-txt">Năm xuất bản: {{ ebooksDetail.manufactureYear }}</p>
              </div>
              <div class="book-detail__btns">
                <div class="actice-book position-rel">
                  <template v-if="ebooksDetail.noNeedActive && ebooksDetail.sachSoUrl">
                    <a :href="ebooksDetail.sachSoUrl"
                      class="btn btn-warning border-rd-20 font-size-15 font-sanpro-semibold line-height-1-2 ml-1"
                      target="_blank">
                      Sử dụng sách
                    </a>
                  </template>
                  <template v-else-if="!ebooksDetail.noNeedActive">
                    <a v-if="authInfo && authInfo.email === emailPublic && !isContainsEmailUnlimited(authInfo.email)"
                      href="javascript:;" class="btn btn-main-light text-center border-rd-20 font-size-16"
                      style="padding: 0 20px;line-height: 30px;" @click="openLoginForm">Kích hoạt</a>
                    <a v-else-if="authInfo && isContainsEmailUnlimited(authInfo.email)">
                      <a href="javascript:;"
                        class="btn btn-warning border-rd-20 font-size-15 font-sanpro-semibold line-height-1-2">
                        Hủy kích hoạt
                      </a>
                    </a>
                    <template v-else>
                      <template v-if="ebooksDetail.actived">
                        <a href="javascript:;"
                          class="btn btn-warning border-rd-20 font-size-15 font-sanpro-semibold line-height-1-2"
                          @click="handleDeactiveBook(ebooksDetail)">
                          Hủy kích hoạt
                        </a>
                        <a v-if="ebooksDetail.sachSoUrl" :href="ebooksDetail.sachSoUrl"
                          class="btn btn-warning border-rd-20 font-size-15 font-sanpro-semibold line-height-1-2 ml-1"
                          target="_blank">
                          Sử dụng sách
                        </a>

                      </template>
                      <!-- <button type="button" class="btn btn-gray btn-pointer-evt-none css-atvd font-size-16 border-rd-20 secondary-color-txt font-sanpro-medium actived" v-if="ebooksDetail.actived">
                      <img src="@/assets/images/active.png" alt="Đã kích hoạt"> 
                      Đã kích hoạt
                    </button> -->
                      <div v-else class="button-not-active" v-click-outside="hidenFormActive">
                        <a href="javascript:;" class="btn btn-main-light text-center border-rd-20 font-size-16"
                          style="padding: 0 20px;line-height: 30px;" @click="toggleFormActive">
                          Kích hoạt
                        </a>
                        <!-- <b-collapse 
                          id="panel_active_book_detail" 
                          class="collapse border-rd-8 bg-color-light" 
                          :visible="openCollapseActive"
                          @show="() => isShowActiveCode = true"
                          @hidden="() => isShowActiveCode = false"
                      >
                        <ActiveCode :bookId="ebooksDetail.bookId" @activeSuccess="handleActiveBookSuccess" />
                      </b-collapse> -->
                      </div>
                    </template>
                  </template>

                </div>
                <!-- {{ isShowFileButton }} - {{ ebooksDetail.documents }} -->
                <!-- <div v-if="isShowFileButton && ebooksDetail && ebooksDetail.documents">               -->
                <!-- v-if="isShowFileButton && ebooksDetail && ebooksDetail.documents" -->
                <div>
                  <!-- <SectionFilesButton :dataSource="trainingDocs" :dataDocPdf="dataDocPdf" :dataVideo="dataVideo" :dataPowerpoint="dataPow" /> -->
                  <SectionFilesButton :dataSource="ebooksDetail.documents" :dataDocPdf="dataDocPdf" :dataVideo="dataVideo"
                    :dataPowerpoint="dataPow" />
                </div>
              </div>
            </div>
            <div class="book-detail__body">
              <b-tabs class="book-detail__tabs">
                <b-tab class="book-detail__tab" active>
                  <template v-slot:title>Mục lục</template>
                  <div class="book-detail__cats">
                    <div class="book-detail__cats-list" role="tablist">
                      <b-card no-body v-for="(item, index) of ebooksDetail.bookIndexs" :key="`cat_${index}`"
                        class="card-item" :class="{ 'active': collapseOpen === `cat_${index}` }">
                        <div class="card-wrap display-block">
                          <b-card-header header-tag="header" role="tab" @click="openCollapse(`cat_${index}`, item)">
                            <div class="cat-head display-flex justify-content-md-between full-width" :class="{
                              'active': collapseOpen === `cat_${index}`,
                              'limit-page': (item.pageNo >= ebooksDetail.limitPage && !ebooksDetail.actived) || (ebooksDetail.limitActivePage && item.pageNo > ebooksDetail.limitActivePage && ebooksDetail.actived) || (item.pageNo >= ebooksDetail.limitPage && authInfo.email === emailPublic)
                            }">
                              <span class="margin-0 font-sanpro-semibold primary-color font-size-16">
                                {{ item.title ? item.title : '' }}
                                <span class="cat-space-title" v-if="item.title">:</span>
                                {{ item.name ? item.name : '' }}
                              </span>
                              <i v-if="item.bookIndexChilds.length > 0" class="fas fa-chevron-down font-size-12"></i>
                            </div>
                          </b-card-header>
                          <b-collapse :id="`cat_${index}`" v-if="item.bookIndexChilds.length > 0" accordion="my-accordion"
                            role="tabpanel">
                            <b-card-body>
                              <ul class="cat-child margin-0 p-0" v-if="item.bookIndexChilds.length > 0">
                                <li v-for="(child, pos) of item.bookIndexChilds" :key="`child_${pos}`">
                                  <a href="javascript:;" @click="openPageOfBook(child)"
                                    :class="{ 'limit-cat': (child.pageNo >= ebooksDetail.limitPage && !ebooksDetail.actived) || (ebooksDetail.limitActivePage && child.pageNo > ebooksDetail.limitActivePage) || (child.pageNo >= ebooksDetail.limitPage && authInfo.email === emailPublic) }">
                                    {{ child.title }}<span class="cat-space-title" v-if="child.title">:</span> {{
                                      child.name }}
                                  </a>
                                </li>
                              </ul>
                              <p class="font-size-18 secondary-color-txt text-center" v-else>Không có bài học nào</p>
                            </b-card-body>
                          </b-collapse>
                        </div>
                      </b-card>
                    </div>
                  </div>
                </b-tab>
                <b-tab class="book-detail__tab">
                  <template v-slot:title>Thông tin</template>
                  <div class="book-detail__info">
                    <div class="box">
                      <h3 class="box__title">Thông tin</h3>
                      <div class="box_body">
                        <div class="row">
                          <div class="col-5 col-md-5 col-lg-3 inner-info">
                            <label>Bộ sách</label>
                          </div>
                          <div class="col-7 col-md-7 col-lg-9 inner-info">
                            <div class="value">{{ ebooksDetail && ebooksDetail.bookTypeName ? ebooksDetail.bookTypeName :
                              "" }}
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-5 col-md-5 col-lg-3 inner-info">
                            <label>Bản quyền thuộc</label>
                          </div>
                          <div class="col-7 col-md-7 col-lg-9 inner-info">
                            <div class="value">Nhà xuất bản Giáo dục Việt Nam</div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-5 col-md-5 col-lg-3 inner-info">
                            <label>Xuất bản</label>
                          </div>
                          <div class="col-7 col-md-7 col-lg-9 inner-info">
                            <div class="value">{{ ebooksDetail.manufactureYear }}</div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-5 col-md-5 col-lg-3 inner-info">
                            <label>Số trang</label>
                          </div>
                          <div class="col-7 col-md-7 col-lg-9 inner-info">
                            <div class="value">{{ ebooksDetail.totalPage - 1 }} trang</div>
                          </div>
                        </div>
                        <p class="book-detail__desc-group line-height-1-4 primary-color-txt font-sanpro-light">
                          {{ ebooksDetail.bookGroupDescription ? ebooksDetail.bookGroupDescription : '' }}
                        </p>
                      </div>
                    </div>
                    <div class="box">
                      <h3 class="box__title">Chủ biên / Tác giả</h3>
                      <div class="box_body">
                        <div class="row" v-for="editorGroup, groupName in groupEditors">
                          <div class="col-5 col-md-5 col-lg-3 inner-info">
                            <label>{{ groupName }}</label>
                          </div>
                          <div class="col-7 col-md-7 col-lg-9 inner-info">
                            <div class="value">
                              <span v-for="(editor, index3) in editorGroup" :key="index3">
                                <span v-if="index3 > 0">, </span>{{ editor && editor.name ? editor.name : "" }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="box box--ralate">
                      <h3 class="box__title">Sách liên quan</h3>
                      <div class="box_body">
                        <div class="list__box__body p-0">
                          <div class="list__book position-rel">
                            <div class="row">
                              <div v-for="(itemBook, index2) in ebooksDetail.bookRelates" :key="index2"
                                class="item col-xl-4 col-lg-4 col-6">
                                <ItemBook :itemBook="itemBook" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <EbookDetail_FAQ />
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { STORE_KEY, LOCAL_SAVE_PAGE_OPEN, LOCAL_SAVE_TAB_LISTPAGE, ID_MODAL_CONFIRM_DEACTIVE_BOOK } from '../_store/constants'
import moment from 'moment'
import { APP_CONFIG } from '@/utils/constants'
import { getAuth } from '@/utils/jwt'
import { EMAIL_PUBLIC, EMAIL_UNLIMITED } from '@/store/auth/constants'
import ClickOutside from 'vue-click-outside'
import { replaceImageResize } from '@/helpers/functions'
import { apiGetBookCodeActived } from './../_api/activecode'

export default {
  name: 'EBookDetail',
  components: {
    SectionFilesButton: () => import('@/components/content-files/SectionFilesButton.vue'),
    EbookDetail_FAQ: () => import('./EbookDetail_FAQ'),
    ItemBook: () => import('./ebooklist/ItemBook.vue'),
    ActiveCode: () => import('./common/ActiveCode.vue')
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      id: this.$route.params.id,
      slug: this.$route.params.slug,
      isReadBook: false,
      slide: 0,
      pageSlides: [
        { id: 1, pathUrl: "1", name: "Tiêu đề 1" },
      ],
      cdnUrl: APP_CONFIG.cdnUrl,
      collapseOpen: '',
      isShowActiveCode: false,
      isShowFileButton: true,
      dataVideo: [],
      dataDocPdf: [],
      dataPow: [],
      trainingDocs: [{
        countDocument: 1,
        createAt: null,
        documentTypeId: 1,
        fileExtension: "pdf,docx,doc",
        isDeleted: null,
        listTrainingDocuments: [{
          createAt: null,
          createBy: null,
          documentId: 482,
          isDelete: null,
          name: "Tài liệu giới thiệu",
          path: "KNTTVCS_HoatDongTraiNghiem1.pdf",
          pathView: "Gioi%20thieu%20sach%20GIAO%20DUC%20THE%20CHAT%201%20(CC18).pdf",
          typeId: 1
        }
        ],
        name: "PDF / Word",
        updatedAt: null
      },
      {
        countDocument: 1,
        createAt: null,
        documentTypeId: 3,
        fileExtension: "mp4",
        isDeleted: null,
        listTrainingDocuments: [{
          createAt: null,
          createBy: null,
          documentId: 482,
          isDelete: null,
          name: "Video test",
          path: "bbb_sunflower_1080p_60fps_normal.mp4",
          pathView: "bbb_sunflower_1080p_60fps_normal.mp4",
          typeId: 1
        }
        ],
        name: "Video",
        updatedAt: null
      }
      ],
      tabActiveInBookList: null,
      authInfo: {},
      emailPublic: EMAIL_PUBLIC,
      openCollapseActive: false,
      emailUnlimited: EMAIL_UNLIMITED
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['ebooksDetail', 'idBookDeactiveDone']),
    // ...mapGetters({
    // ebooksDetail: STORE_KEY + '/ebooksDetail',
    //bookRelation: STORE_KEY + '/bookRelation'
    // }),
    ...mapState('auth', ['loginPopupData']),
    ...mapState('common', ['idActiveBookSuccessheader', 'idBookActiveSuccess']),
    bookId() {
      return this.$route.params.id;
    },
    groupEditors() {
      return this.groupBy(this.ebooksDetail.bookEditors, 'title')
    }
  },
  watch: {
    'bookId': function (id) {
      this.bookDetail(id);
    },
    loginPopupData(newVal) {
      if (newVal && Object.keys(newVal).length) {
        this.authInfo = newVal;
        this.togglePanelActiveCode();
      }
    },
    idActiveBookSuccessheader(newVal) {
      if (newVal === this.bookId) {
        let dataNew = { ...this.ebooksDetail, actived: true };
        this.setBookDetail(dataNew);
      }
    },
    idBookActiveSuccess(newVal) {
      if (parseInt(newVal) === this.ebooksDetail.bookId) {
        this.handleActiveBookSuccess()
      }
    },
    idBookDeactiveDone(newVal) {
      if (newVal && newVal === this.ebooksDetail.bookId) {
        this.setBookDetail({ ...this.ebooksDetail, actived: false })
      }
    }
  },
  created() {
    this.bookDetail(this.bookId);
    this.authInfo = getAuth();
    // console.log('meow', this.id);
    this.actionSetBookIdForError(this.id)
  },
  mounted() {
    this.actionGetTraningId(this.id)
    this.tabActiveInBookList = localStorage.getItem(LOCAL_SAVE_TAB_LISTPAGE);
  },
  methods: {
    ...mapActions('common', ['setLoading', 'acSetDataBookActiveWant', 'acToggleModalActiveBook', 'actionSetBookIdForError']),
    ...mapActions('auth', ['setToggleLoginForm']),
    ...mapActions(STORE_KEY, ['getEBooksDetail', 'setBookDetail', "actionGetTraningId", 'acSetDataBookDeActive']),
    isContainsEmailUnlimited(email) {

      let listEmailUnlimited = this.emailUnlimited.split(',')
      console.log(email, listEmailUnlimited)
      return listEmailUnlimited.indexOf(email) > -1
    },
    bookDetail(bookId) {
      let self = this;
      self.setLoading(true);
      self.getEBooksDetail(bookId).then().catch().finally(() => self.setLoading(false));
      // this.$store.dispatch(STORE_KEY + '/getEBooksDetail', bookId);
    },

    thumbUrl(filename) {
      return require(`@/assets/img/${filename}`);
    },

    pageUrl(index) {
      return require(`@/assets/images/page-sample-${index}.jpg`);
    },

    dateFormat: function (date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },

    readBook() {
      this.isReadBook = true;
    },
    prev() {
      this.$refs.myCarousel.prev()
    },
    next() {
      this.$refs.myCarousel.next()
    },
    readPage(index) {
      this.$refs.myCarousel.setSlide(index - 1)
    },

    openCollapse(id, cat) {
      if (cat.bookIndexChilds.length > 0) {
        this.collapseOpen = this.collapseOpen === id ? '' : id;
        this.$root.$emit('bv::toggle::collapse', id)
      } else {
        this.openPageOfBook(cat)
      }
    },

    async openPageOfBook(data) {
      let self = this;
      if (data.pageNo >= this.ebooksDetail.limitPage && this.authInfo.email === this.emailPublic) {
        this.openLoginForm()
      } else if ((data.pageNo >= this.ebooksDetail.limitPage && !this.ebooksDetail.actived) || (this.ebooksDetail.limitActivePage && data.pageNo > this.ebooksDetail.limitActivePage)) {
        this.acToggleModalActiveBook(true)
      } else if (data && !self.checkPageLimit(data)) {
        await data.pageNo && localStorage.setItem(LOCAL_SAVE_PAGE_OPEN, data.pageNo)

        self.$router.push({ name: 'ebook-read-book', params: { id: self.ebooksDetail.bookId, slug: self.ebooksDetail.slug } });
      }
    },

    checkPageLimit(page) {
      return (page.pageNo >= this.ebooksDetail.limitPage && !this.ebooksDetail.actived) || (this.ebooksDetail.limitActivePage && page.pageNo > this.ebooksDetail.limitActivePage) || (page.pageNo >= this.ebooksDetail.limitPage && this.authInfo.email === this.emailPublic)
    },

    groupBy(array, key) {
      const result = {}
      if (array && array.length) {
        array.forEach(item => {
          if (!result[item[key]]) {
            result[item[key]] = []
          }
          result[item[key]].push(item)
        })
      }
      return result
    },

    handleActiveBookSuccess() {
      // this.$root.$emit('bv::toggle::collapse', 'panel_active_book_detail');
      let dataNew = { ...this.ebooksDetail, actived: true };
      this.setBookDetail(dataNew);
    },

    async openLoginForm() {
      const request = await fetch(APP_CONFIG.dataUrl + "IsLoginkeyCloak");
      const response = await request.json();
      if (response.isLoginKeyClock === 0) {
        this.setToggleLoginForm(true);
      }
      else {
        this.onLoginSSOKeyCloak(response)
      }
    },
    onLoginSSOKeyCloak(configKeyclock) {
      const pageUrl = window.location.href;
      window.location.href = configKeyclock.urlServerKeyCloak + "/realms/" + configKeyclock.realm + "/protocol/openid-connect/auth?response_type=code&client_id=" + configKeyclock.audience + "&redirect_uri=" + window.location.origin + configKeyclock.redirect + '?urlReturn=' + pageUrl
    },
    togglePanelActiveCode() {
      if (this.authInfo.email !== this.emailPublic) {
        setTimeout(() => {
          this.$root.$emit('bv::toggle::collapse', 'panel_active_book_detail');
        }, 500)
      }
    },

    toggleFormActive() {
      this.acSetDataBookActiveWant({ ...this.ebooksDetail })
      setTimeout(() => {
        this.acToggleModalActiveBook(true)
      }, 200)
      // this.openCollapseActive = !this.openCollapseActive;
      // this.$root.$emit('bv::toggle::collapse', 'panel_active_book_detail');
    },

    hidenFormActive() {
      this.openCollapseActive = false;
    },

    handleResizeImg(link) {
      return replaceImageResize(link, { width: 285, height: 404 })
    },

    async handleDeactiveBook(book) {
      if (!book || !book.bookId || !book.esStampId) {
        return
      }
      const { bookId, esStampId } = book
      const dataBookCode = await apiGetBookCodeActived(esStampId)
      if (dataBookCode) {
        const bookCode = dataBookCode.stamp
        this.acSetDataBookDeActive({ bookId, esStampId, bookCode })
        this.$bvModal.show(ID_MODAL_CONFIRM_DEACTIVE_BOOK)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
// // Variables
@import './../../../assets/scss/_variables';

#panel_active_book_detail {
  position: absolute;
  left: 0;
  top: 50px;
  z-index: 9;
}

.actice-book {
  margin: 15px 0 5px;

  .actived {
    padding: 3px 15px 5px;
    letter-spacing: 0.03em;

    img {
      max-width: 16px;
    }
  }
}

.cat-head {
  &.limit-page {
    * {
      @extend .secondary-color-txt;
    }
  }
}

.limit-cat {
  // pointer-events: none;
  color: $secondary_text_color !important;
}
</style>